export default function identity() {
  return true
}



// WEBPACK FOOTER //
// ../src/utils/identity.js